module.exports = __webpack_public_path__ + "static/media/bannerVideo.c8e3edbb.mov";